import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router';
import {
  connect
} from 'react-redux';
import {
  bindActionCreators
} from 'redux';
import {
  changeColor,
  clearDraw
} from '../../../actions/ts_overlay_actions.js';
import {
  updateModal
} from '../../../actions/modal.js';
import {
  updateCanvas
} from '../../../actions/ts_canvas_actions.js';
import {
  changeStamp
} from '../../../actions/ts_stamp_actions.js';
import {
  Button,
  Modal,
  Grid,
  Row,
  Col,
  Clearfix,
  ButtonToolbar,
  DropdownButton,
  MenuItem,
  ButtonGroup,
  Dropdown,
  Accordion,
  Panel,
  PanelGroup
} from 'react-bootstrap';
var Letters = React.createClass({
  stampSelected(stamp) {
    var {
      dispatch,
      overlay
    } = this.props;
    dispatch(clearDraw(overlay.color, overlay.color1, overlay.color2));
    dispatch(changeStamp(stamp, 'white'));
    dispatch(updateModal(false, null));
  },

  render() {
    var {
      overlay,
      map,
      currentUser
    } = this.props;
    var cellStyle= "fa-lg pointerCursor";
    if(overlay.color == 'blue'){
      cellStyle ="fa-lg icon-blue pointerCursor";
    }
    if(overlay.color == 'red'){
        cellStyle ="fa-lg icon-red pointerCursor";
    }

    return (
      <div>
        <Grid>
        <Row>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('A');}} className={cellStyle} >A</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('B');}} className={cellStyle} >B</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('C');}} className={cellStyle} >C</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('D');}} className={cellStyle} >D</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('E');}} className={cellStyle} >E</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('F');}} className={cellStyle} >F</Col>
        </Row>
        <Row>
        <Col md={1} xs={2}><br/></Col>
        </Row>
        <Row>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('G');}} className={cellStyle} >G</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('H');}} className={cellStyle} >H</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('I');}} className={cellStyle} >I</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('J');}} className={cellStyle} >J</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('K');}} className={cellStyle} >K</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('L');}} className={cellStyle} >L</Col>
        </Row>
        <Row>
        <Col md={1} xs={2}><br/></Col>
        </Row>
        <Row>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('M');}} className={cellStyle} >M</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('N');}} className={cellStyle} >N</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('O');}} className={cellStyle} >O</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('P');}} className={cellStyle} >P</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('Q');}} className={cellStyle} >Q</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('R');}} className={cellStyle} >R</Col>
        </Row>
        <Row>
        <Col md={1}><br/></Col>
        </Row>
        <Row>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('S');}} className={cellStyle} >S</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('T');}} className={cellStyle} >T</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('U');}} className={cellStyle} >U</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('V');}} className={cellStyle} >V</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('W');}} className={cellStyle} >W</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('X');}} className={cellStyle} >X</Col>
        </Row>
        <Row>
        <Col md={1} xs={2}><br/></Col>
        </Row>
        <Row>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('Y');}} className={cellStyle} >Y</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('Z');}} className={cellStyle} >Z</Col>
        </Row>
      </Grid>
    </div>
    );
  }
});


module.exports = connect((state) => {
  return {
    overlay: state.overlay,
    map: state.map,
    currentUser: state.currentUser,
    stamp: state.stamp
  }
})(Letters);



// WEBPACK FOOTER //
// ./src/app/components/tools/stamps/letters.js